module.exports = __webpack_public_path__ + "img/thumb_26.3f912363.jpg";